module.exports = __webpack_public_path__ + "img/la-solid-900.a813034.svg";